import { Shimmer } from "./shimmer";

// Users Page Shimmer
export function UsersPageShimmer() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <Shimmer className="h-8 w-32 mb-2" />
        <Shimmer className="h-4 w-64" />
      </div>

      {/* Search and Filter Row */}
      <div className="flex flex-col sm:flex-row gap-4">
        <Shimmer className="h-10 flex-1 rounded-md" />
        <Shimmer className="h-10 w-48 rounded-md" />
      </div>

      {/* Stats Cards */}
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-20 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-24 mb-2" />
          <Shimmer className="h-8 w-20" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-28 mb-2" />
          <Shimmer className="h-8 w-24" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-20 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-card border rounded-lg p-6">
        <div className="mb-4">
          <Shimmer className="h-6 w-24" />
        </div>
        <UsersTableSkeleton />
      </div>
    </div>
  );
}

// Walks Page Shimmer
export function WalksPageShimmer() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <Shimmer className="h-8 w-28 mb-2" />
        <Shimmer className="h-4 w-72" />
      </div>

      {/* Search and Filter Row */}
      <div className="flex flex-col sm:flex-row gap-4">
        <Shimmer className="h-10 flex-1 rounded-md" />
        <Shimmer className="h-10 w-48 rounded-md" />
      </div>

      {/* Stats Cards */}
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-24 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-32 mb-2" />
          <Shimmer className="h-8 w-20" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-28 mb-2" />
          <Shimmer className="h-8 w-24" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-20 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-card border rounded-lg p-6">
        <div className="mb-4">
          <Shimmer className="h-6 w-24" />
        </div>
        <WalksTableSkeleton />
      </div>
    </div>
  );
}

// Events Page Shimmer
export function EventsPageShimmer() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <Shimmer className="h-8 w-32 mb-2" />
        <Shimmer className="h-4 w-80" />
      </div>

      {/* Create Event Button */}
      <div className="flex justify-end">
        <Shimmer className="h-10 w-32 rounded-md" />
      </div>

      {/* Stats Cards */}
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-24 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-28 mb-2" />
          <Shimmer className="h-8 w-20" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-32 mb-2" />
          <Shimmer className="h-8 w-24" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-20 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
      </div>

      {/* Events Grid */}
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <EventCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}

// Schools Page Shimmer
export function SchoolsPageShimmer() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <Shimmer className="h-8 w-32 mb-2" />
        <Shimmer className="h-4 w-68" />
      </div>

      {/* Search and Create Button Row */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between">
        <Shimmer className="h-10 flex-1 max-w-md rounded-md" />
        <Shimmer className="h-10 w-36 rounded-md" />
      </div>

      {/* Stats Cards */}
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-24 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-28 mb-2" />
          <Shimmer className="h-8 w-20" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-32 mb-2" />
          <Shimmer className="h-8 w-24" />
        </div>
      </div>

      {/* Schools Grid */}
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 9 }).map((_, i) => (
          <SchoolCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}

// Ideas Page Shimmer
export function IdeasPageShimmer() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <Shimmer className="h-8 w-28 mb-2" />
        <Shimmer className="h-4 w-76" />
      </div>

      {/* Create Idea Button */}
      <div className="flex justify-end">
        <Shimmer className="h-10 w-32 rounded-md" />
      </div>

      {/* Stats Cards */}
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-20 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-24 mb-2" />
          <Shimmer className="h-8 w-20" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-28 mb-2" />
          <Shimmer className="h-8 w-24" />
        </div>
        <div className="bg-card border rounded-lg p-4">
          <Shimmer className="h-4 w-20 mb-2" />
          <Shimmer className="h-8 w-16" />
        </div>
      </div>

      {/* Ideas Grid */}
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <IdeaCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}

// Table Skeletons
function UsersTableSkeleton() {
  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="grid grid-cols-5 gap-4 pb-2 border-b">
        <Shimmer className="h-4 w-8" />
        <Shimmer className="h-4 w-16" />
        <Shimmer className="h-4 w-12" />
        <Shimmer className="h-4 w-14" />
        <Shimmer className="h-4 w-16" />
      </div>

      {/* Rows */}
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="grid grid-cols-5 gap-4 items-center py-2">
          <Shimmer className="h-4 w-8" />
          <Shimmer className="h-4 w-24" />
          <Shimmer className="h-4 w-32" />
          <Shimmer className="h-4 w-20" />
          <div className="flex space-x-2">
            <Shimmer className="h-8 w-8 rounded" />
            <Shimmer className="h-8 w-8 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

function WalksTableSkeleton() {
  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="grid grid-cols-6 gap-4 pb-2 border-b">
        <Shimmer className="h-4 w-8" />
        <Shimmer className="h-4 w-16" />
        <Shimmer className="h-4 w-14" />
        <Shimmer className="h-4 w-12" />
        <Shimmer className="h-4 w-16" />
        <Shimmer className="h-4 w-16" />
      </div>

      {/* Rows */}
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="grid grid-cols-6 gap-4 items-center py-2">
          <Shimmer className="h-4 w-8" />
          <Shimmer className="h-4 w-24" />
          <Shimmer className="h-4 w-16" />
          <Shimmer className="h-4 w-12" />
          <Shimmer className="h-6 w-16 rounded-full" />
          <div className="flex space-x-2">
            <Shimmer className="h-8 w-8 rounded" />
            <Shimmer className="h-8 w-8 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}

// Card Skeletons
function EventCardSkeleton() {
  return (
    <div className="bg-card border rounded-lg p-6">
      <div className="space-y-4">
        <div className="flex justify-between items-start">
          <Shimmer className="h-6 w-32" />
          <Shimmer className="h-6 w-16 rounded-full" />
        </div>
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-3/4" />
        <div className="flex justify-between items-center pt-2">
          <Shimmer className="h-4 w-24" />
          <Shimmer className="h-4 w-20" />
        </div>
        <div className="flex space-x-2 pt-2">
          <Shimmer className="h-8 w-16 rounded" />
          <Shimmer className="h-8 w-16 rounded" />
        </div>
      </div>
    </div>
  );
}

function SchoolCardSkeleton() {
  return (
    <div className="bg-card border rounded-lg p-6">
      <div className="space-y-4">
        <div className="flex items-center space-x-3">
          <Shimmer className="w-12 h-12 rounded-full" />
          <div className="flex-1">
            <Shimmer className="h-5 w-28" />
            <Shimmer className="h-4 w-20 mt-1" />
          </div>
        </div>
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-2/3" />
        <div className="flex justify-between items-center pt-2">
          <Shimmer className="h-4 w-16" />
          <Shimmer className="h-4 w-20" />
        </div>
        <div className="flex space-x-2 pt-2">
          <Shimmer className="h-8 w-16 rounded" />
          <Shimmer className="h-8 w-16 rounded" />
        </div>
      </div>
    </div>
  );
}

function IdeaCardSkeleton() {
  return (
    <div className="bg-card border rounded-lg p-6">
      <div className="space-y-4">
        <div className="flex justify-between items-start">
          <Shimmer className="h-6 w-36" />
          <Shimmer className="h-6 w-20 rounded-full" />
        </div>
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-5/6" />
        <Shimmer className="h-4 w-2/3" />
        <div className="flex justify-between items-center pt-2">
          <div className="flex items-center space-x-2">
            <Shimmer className="w-6 h-6 rounded-full" />
            <Shimmer className="h-4 w-20" />
          </div>
          <Shimmer className="h-4 w-16" />
        </div>
        <div className="flex space-x-2 pt-2">
          <Shimmer className="h-8 w-16 rounded" />
          <Shimmer className="h-8 w-20 rounded" />
        </div>
      </div>
    </div>
  );
}
